import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        backgroundColor: "#000",
        justifyContent: "center",
        zIndex: 9999999,
        position: "fixed",
        width: "100%",
    },
    container: {
        width: "100%",
        maxWidth: "1366px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "20px 0",
        [theme.breakpoints.up('lg')]: {
            margin: '0 96px',
        },
        [theme.breakpoints.down('md')]: {
            margin: '0 24px',
            paddingBottom: 12,
            paddingTop: 16
        },
    },
    logoMfs: {
        width: "175px",
        height: "45px",
        objectFit: "contain",
        [theme.breakpoints.down('sm')]: {
            width: "140px",
            height: "36px",
        },
    },
    menu: {
        '& > a': {
            color: "#fff",
            textDecoration: "none",
            fontSize: "16px",
            margin: "0 16px",
            fontWeight: "600",
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    menuItem: {
        color: "#fff",
        textDecoration: "none",
        fontSize: "16px",
        margin: "0 16px",
        fontWeight: "600",
    },
    articlesMenuContainer: {
        position: "relative",
        display: "inline-block",
        margin: "0 16px",
    },
    articlesLink: {
        color: "#fff",
        textDecoration: "none",
        fontSize: "16px",
        fontWeight: "600",
        cursor: "pointer",
        display: "block",
        padding: "8px 0",
    },
    articlesDropdown: {
        position: "absolute",
        top: "100%",
        left: "0",
        backgroundColor: "#1a1a1a",
        borderRadius: "8px",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        minWidth: "200px",
        zIndex: 999999999,
        marginTop: "0px",
        padding: "8px 0",
        animation: "fadeIn 0.2s ease-in-out",
        // Menambahkan area yang lebih toleran
        "&::before": {
            content: '""',
            position: "absolute",
            top: "-10px",
            left: "0",
            right: "0",
            height: "10px",
            backgroundColor: "transparent",
        },
    },
    dropdownItem: {
        display: "block",
        padding: "12px 20px",
        color: "#fff",
        textDecoration: "none",
        fontSize: "16px",
        fontWeight: "500",
        transition: "all 0.2s ease",
        cursor: "pointer",
        border: "none",
        backgroundColor: "transparent",
        width: "100%",
        textAlign: "left",
        "&:hover": {
            backgroundColor: "rgba(64, 61, 227, 0.1)",
            color: "#FFF",
        },
        "&:first-child": {
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
        },
        "&:last-child": {
            borderBottomLeftRadius: "8px",
            borderBottomRightRadius: "8px",
        },
    },
    loginButton: {
        backgroundColor: "#403DE3",
        color: "#FFF",
        height: 42,
        borderRadius: 42 / 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "600",
        fontSize: "14px",
        cursor: "pointer",
        border: "none",
        outline: "none",
        padding: "0 24px",
        transition: "all 0.3s ease",
        textDecoration: "none",
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },

    loginIcon: {
        width: '14px',
        height: '14px',
        objectFit: 'contain',
        marginRight: '8px'
    },
    icnStyle: {
        height: "24px",
        width: "24px",
        color: "#fff",
        transition: "all 0.3s ease",
    },
    ctnAccount: {
        display: "flex",
        alignItems: "center",
        gap: "16px",
    },
    ctnAvatar: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        position: "relative",
        cursor: "pointer",
        "& > img": {
            width: 30,
            height: 30,
            borderRadius: 30 / 2,
            overflow: "hidden",
        },
    },
    accountName: {
        fontSize: 16,
        fontWeight: 600,
        color: "#fff",
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    accountDropdown: {
        position: "absolute",
        top: "100%",
        left: "0",
        backgroundColor: "#1a1a1a",
        borderRadius: "8px",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        minWidth: "200px",
        zIndex: 999999999,
        marginTop: "0px",
        padding: "8px 0",
        animation: "fadeIn 0.2s ease-in-out",
        // Menambahkan area yang lebih toleran
        "&::before": {
            content: '""',
            position: "absolute",
            top: "-10px",
            left: "0",
            right: "0",
            height: "10px",
            backgroundColor: "transparent",
        },
        [theme.breakpoints.down(1360)]: {
            [theme.breakpoints.up(960)]: {
                left: -90,
                marginTop: 10
            }
        },
        [theme.breakpoints.down(965)]: {
            left: "-116px",
            marginTop: 10
        },
    },
    mobileMenu: {
        display: "none",
        [theme.breakpoints.down('sm')]: {
            display: 'block',
        },
        "& .hamburger": {
            position: "relative",
            width: "32px",
            height: "32px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 0,
            color: "#fff",
            "&:hover": {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
        },
        "& .hamburger-box": {
            position: "relative",
            width: "24px",
            height: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "transform 0.3s ease",
        },
        "& .hamburger--spin.is-active .hamburger-box": {
            transform: "rotate(180deg)",
        },
        "& .hamburger--spin.is-active .icnStyle": {
            transform: "rotate(45deg)",
        },
    },
    icnUser: {
        color: "#fff",
        fontSize: "18px",
    },
    userMobile: {
        width: 28,
        height: 28,
        borderRadius: 28 / 2,
        border: "1px solid #fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    "@keyframes fadeIn": {
        from: {
            opacity: 0,
            transform: "translateY(-10px)",
        },
        to: {
            opacity: 1,
            transform: "translateY(0)",
        },
    },
    ctnLanguageDesktop: {
        display: "flex",
        alignItems: "center",
        gap: "32px",
    },
    ctnLanguage: {
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
        [theme.breakpoints.down(1360)]: {
            [theme.breakpoints.up(960)]: {
                "& > div:first-child": {
                    width: 282
                },
            }
        }
    }
}));

export default useStyles;